module.exports = __webpack_public_path__ + "static/media/invoices-import-template.8008bcc9.xlsx";